<div class="qa-choice-display-type input-group mb-1" *ngIf="(question.displayType && (question.displayType == 'radio' || question.displayType == 'dropdown'))">
  <span class="input-group-addon">{{_(KEYS.EDITOR.DISPLAY_TYPE)}}</span>
  <select class="form-control qa-custom-select" [(ngModel)]="question.displayType">
    <option value="radio">{{_(KEYS.EDITOR.RADIO_BUTTONS)}}</option>
    <option value="dropdown">{{_(KEYS.EDITOR.DROPDOWN)}}</option>
  </select>
</div>
<div class="form-check qa-pdf-inline-choices" *ngIf="supportsPdfInlineChoices">
  <input
    type="checkbox"
    class="form-check-input"
    id="qa-pdf-inline-choices-{{question.id}}"
    [(ngModel)]="question.options.pdfInlineChoices"
  >
  <label class="form-check-label" for="qa-pdf-inline-choices-{{question.id}}">{{_(KEYS.EDITOR.PDF_INLINE_CHOICES)}}</label>
</div>
<div class="qa-option-row" *ngFor="let answer of question.elements; let position = index; trackBy: trackByAnswerId">
    <span class="qa-option-number">{{position + 1}}</span>
    <div class="qa-option-order">
      <button type="button" (click)="onPositionChange(position, position - 1)" [disabled]="position === 0"
              [attr.aria-label]="_(KEYS.EDITOR.MOVE_UP)" [ngbTooltip]="_(KEYS.EDITOR.MOVE_UP)" container="body"><i class="fa fa-angle-up"></i></button>
      <button type="button" (click)="onPositionChange(position, position + 1)" [disabled]="position === question.elements.length - 1"
              [attr.aria-label]="_(KEYS.EDITOR.MOVE_DOWN)" [ngbTooltip]="_(KEYS.EDITOR.MOVE_DOWN)" container="body"><i class="fa fa-angle-down"></i></button>
    </div>
    <div class="qa-option-content">
      <div class="qa-option-label-row">
        <span class="qa-option-type" role="img" [ngSwitch]="answer.displayType || question.displayType"
              [attr.aria-label]="_((answer.displayType || question.displayType) === 'text' ? KEYS.EDITOR.FREE_TEXT : KEYS.EDITOR.CHOICE)">
          <i *ngSwitchCase="'radio'" class="fa fa-dot-circle-o" aria-hidden="true"></i>
          <i *ngSwitchCase="'dropdown'" class="fa fa-chevron-circle-down" aria-hidden="true"></i>
          <i *ngSwitchCase="'checkbox'" class="fa fa-check-square-o" aria-hidden="true"></i>
          <i *ngSwitchCase="'text'" class="fa fa-pencil-square-o" aria-hidden="true"></i>
        </span>
        <div class="qa-option-text qa-fake-input" qaFroalaAutoScroll>
          <app-qa-lazy-froala [focusRequested]="previewFocusTarget === 'answer-' + position"
                              (focusHandled)="previewFocusHandled.emit()" [options]="getAnswerEditorOptions(position)" [(model)]="answer.title[locale]"
                              (blur)="updateElement()"></app-qa-lazy-froala>
        </div>
      </div>
      <div class="qa-option-field-label" *ngIf="(answer.displayType || question.displayType) === 'text'">
        {{_(KEYS.EDITOR.FREE_TEXT)}}
      </div>
      <div class="qa-option-meta" *ngIf="getScoringInfo(answer) || answer.conditions?.mark || answer.assets?.audio?.length">
        <span *ngIf="getScoringInfo(answer) as score"><i class="fa fa-sort-numeric-asc"></i> {{score.variableName}}: {{score.value}}</span>
        <span *ngIf="answer.conditions?.mark" [ngbTooltip]="_(KEYS.EDITOR.MARK)"><i class="fa fa-bookmark"></i></span>
        <span *ngIf="answer.assets?.audio?.length" [ngbTooltip]="_(KEYS.EDITOR.AUDIO)"><i class="fa fa-volume-up"></i></span>
      </div>
    </div>
    <div ngbDropdown container="body" placement="bottom-right" class="qa-option-actions">
      <button type="button" class="qa-option-more" ngbDropdownToggle [attr.aria-label]="_(KEYS.EDITOR.OPTIONS) + ': ' + (position + 1)">
        <i class="fa fa-ellipsis-v"></i>
      </button>
      <div ngbDropdownMenu class="qa-option-menu">
        <button ngbDropdownItem (click)="onOpenMediaCenterModal('audio', answer)"><i class="fa fa-volume-up"></i> {{_(KEYS.EDITOR.AUDIO)}}</button>
        <button ngbDropdownItem *ngIf="answer.assets?.audio?.length" (click)="onDeleteAnswerMedia('audio', answer)">
          <i class="fa fa-volume-off"></i> {{_(KEYS.EDITOR.REMOVE_AUDIO)}}
        </button>
        <button ngbDropdownItem (click)="onToggleMark(answer)" [attr.aria-pressed]="!!answer.conditions?.mark">
          <i class="fa" [ngClass]="answer.conditions?.mark ? 'fa-check-square-o' : 'fa-bookmark-o'"></i> {{_(KEYS.EDITOR.MARK)}}
        </button>
        <button ngbDropdownItem (click)="onScoringModal(position)"><i class="fa fa-sort-numeric-asc"></i> {{_(KEYS.EDITOR.SCORING)}}</button>
        <button ngbDropdownItem (click)="onVariablesModal(position)"><i class="fa fa-code"></i> {{_(KEYS.EDITOR.VARIABLES)}}</button>
        <div class="dropdown-divider"></div>
        <button ngbDropdownItem class="text-danger" (click)="onDeleteAnswer(position)" [disabled]="!!answer.undeletable"
                [attr.disabled]="answer.undeletable ? true : null" [attr.aria-disabled]="!!answer.undeletable">
          <i class="fa fa-trash-o"></i> {{_(KEYS.EDITOR.REMOVE)}}
        </button>
      </div>
    </div>
</div>
<div class="btn-group mt-2">
  <button class="btn btn-sm btn-success" (click)="onAddAnswer()" (keydown)="onAddAnswerKeyDown($event)" #addAnswerBtn>
    <i class="fa fa-plus"></i> {{_(KEYS.EDITOR.ADD_ANSWER)}}
  </button>
</div>
